// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"042bb37f","239":"dfdb0d71","453":"d855a71b","455":"b644a4e5"}[chunkId] + ".chunk.js";
};